import { connect } from 'react-redux'
import { getHistory } from 'lib/history'
import { find } from 'lodash'

import { SET_ACTIVE_SORT_PARAMS, setActiveSortParams } from 'store/actions'

const activeSortParamsReducer = (state = [], action) => {
  switch (action.type) {
    case SET_ACTIVE_SORT_PARAMS:
      return action.activeSortParams
    default:
      return state
  }
}

export default activeSortParamsReducer

export const withActiveSortParams = () => {
  const WithActiveSortParams = (WrappedComponent) =>
    connect(
      (state, ownProps) => {
        // user (manually) selected sorting
        let sortParams = state.activeSortParams
        if (!sortParams) {
          // find active category by looking up location's path vs redux state (url slug) categories
          // connected comp within a router we have a location's props (SSR should be handled too)
          let { location } = ownProps
          if (!location) {
            location = getHistory(ownProps).getCurrentLocation() // pass ownProps in case of SSR
          }
          const [activeCategorySlug] = location.pathname.split('/').slice(-1)
          const activeCategory = find(
            state.categories || [],
            (c) => c.urlSlug === activeCategorySlug
          )
          sortParams = activeCategory
            ? {
                sort: activeCategory.sortType,
                order: activeCategory.sortOrder,
              }
            : {}
        }
        return {
          sortParams,
          ...ownProps,
        }
      },
      (dispatch) => ({
        setActiveSortParams: (params) => dispatch(setActiveSortParams(params)),
      })
    )(WrappedComponent)

  return WithActiveSortParams
}
